<template>
  <div class="relative" :style="articleWidth ? `--container-mw: ${widthMapping[articleWidth]}` : null">
    <div class="grid" :class="{ 'sticky top-0': heroEffect === 'parallax' }">
      <div class="relative grid-area-stack" style="max-height: 90vh">
        <cms-shared-media v-if="media" :media />
      </div>
      <div class="z-1 w-full flex items-end pb-10 container grid-area-stack">
        <div class="space-y-2" :class="titleColor">
          <p v-if="!hidePageDate" class="text-md fw-medium">
            {{ date }}
          </p>
          <h1 class="display-3">
            {{ title }}
          </h1>
          <p class="subtitle-2">
            {{ subtitle }}
          </p>
        </div>
      </div>
    </div>
    <div v-style:bg="backgroundColor" class="relative z-1 flow-root">
      <div class="my-6">
        <slot />
      </div>

      <div v-if="relatedArticles.length" class="mb-10 container">
        <h2 class="body-2 mb-4">
          {{ $t.relatedBlogs }}
        </h2>
        <vf-carousel-elevate class-container="gap-x-1" :show-arrows="false">
          <vf-article-card-v2
            v-for="article in relatedArticles"
            :key="article.id"
            style="max-width: 23.75rem"
            v-bind="article"
          />
        </vf-carousel-elevate>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { PageContent } from '#types/page'

const { page } = defineProps<{ page: PageContent }>()

const { getSearch, getMediaUrl } = useCms()

const {
  articleWidth,
  backgroundColor,
  date,
  headerStyle = 'light',
  heroEffect,
  hidePageDate,
  media,
  relatedQuery,
  subtitle,
  title,
} = page

useSchemaOrg([
  defineArticle({
    headline: title,
    description: subtitle,
    datePublished: date
  })
])

const widthMapping = {
  narrow: '61.375rem',
}

const titleColor = headerStyle === 'light' ? 'c-white' : 'c-brand-4'

const RELATED_ARTICLES_COUNT = '4'

let relatedArticles: any[] = []

if (relatedQuery) {
  const query = new URLSearchParams(relatedQuery)
  query.set('limit', RELATED_ARTICLES_COUNT)

  const data = await getSearch('article', { ...Object.fromEntries(query), limit: 4 })

  relatedArticles = (data?.result || []).map((article) => ({
    ...article,
    to: article.url,
    image: {
      src: getMediaUrl(article.picture?.url),
      alt: article.picture?.alt || article.title
    },
    tags: [article.tags[0]?.label]
  }))
}
</script>
